import { SidebarMenuItem } from "../../../../_metronic/layout/components/sidebar/sidebar-menu/SidebarMenuItem"
import { SidebarMenuItemWithSub } from "../../../../_metronic/layout/components/sidebar/sidebar-menu/SidebarMenuItemWithSub"

import { useAuth } from "../../auth"
import { useAppView } from "../../core/app/AppViewContext"

const ApplicantSidebarMenu = () => {
    const {hasRole} = useAuth()
    const { cntApplications, cntDLMSiteInspectApplications, cntDLMDOCApplications, cntDLMLabelApplications } = useAppView();

    return(
        <>
        <SidebarMenuItem
            to='/company/application-management/applications'        
            title="COC Applications"
            showCount={cntApplications}        
            fontIcon='bi-card-checklist'
            icon='/media/icons/duotune/general/gen028.svg'
        />    
        <SidebarMenuItem
            to='/company/certificate-management/certificates'        
            title="Certificates" 
            fontIcon='bi-archive'
            icon='/media/icons/duotune/coding/cod002.svg'
        />

        <SidebarMenuItemWithSub 
            to="/company/doclabel/siteinspections" 
            title='Site Inspections' 
            icon='/media/icons/duotune/general/gen068.svg'
        >
            <SidebarMenuItem 
                to='/company/doclabel/siteinspection-applications-list'
                title='Applications' 
                showCount={cntDLMSiteInspectApplications}
                fontIcon='bi-card-checklist'
                icon='/media/icons/duotune/general/gen028.svg'
            />
            <SidebarMenuItem 
                to='/company/doclabel/siteinspections-list'
                title='Inspections List'                 
                fontIcon='bi-card-checklist'
                icon='/media/icons/duotune/abstract/abs015.svg'
            />
        </SidebarMenuItemWithSub>
        <SidebarMenuItemWithSub 
            to="/company/doclabel/docs" 
            title='DOCs' 
            icon='/media/icons/duotune/general/gen048.svg'
        >
            <SidebarMenuItem 
                to='/company/doclabel/doc-applications-list'
                title='Applications' 
                showCount={cntDLMDOCApplications}
                fontIcon='bi-card-checklist'
                icon='/media/icons/duotune/general/gen028.svg'
            />
            <SidebarMenuItem 
                to='/company/doclabel/doc-list'
                title='DOC List' 
                fontIcon='bi-card-checklist'
                icon='/media/icons/duotune/abstract/abs015.svg'
            />
            <SidebarMenuItem
                to="/company/file-uploader" 
                title="Upload Files" 
                icon='/media/icons/duotune/files/fil022.svg'
                fontIcon='bi-file'
            />
        </SidebarMenuItemWithSub>

        <SidebarMenuItemWithSub 
            to="/company/doclabel/labels" 
            title='Labels' 
            icon='/media/icons/duotune/general/gen056.svg'
        >
            <SidebarMenuItem 
                to='/company/doclabel/label-applications-list'
                title='Applications' 
                showCount={cntDLMLabelApplications}
                fontIcon='bi-card-checklist'
                icon='/media/icons/duotune/general/gen028.svg'
            />            
            <SidebarMenuItem 
                to='/company/doclabel/roi-list'
                title='ROI List' 
                fontIcon='bi-card-checklist'
                icon='/media/icons/duotune/abstract/abs015.svg'
            />
            <SidebarMenuItem 
                to='/company/doclabel/labels-list'
                title='Labels' 
                fontIcon='bi-card-checklist'
                icon='/media/icons/duotune/general/gen021.svg'
            />
            <SidebarMenuItem
                to="/company/file-uploader" 
                title="Upload Files" 
                icon='/media/icons/duotune/files/fil022.svg'
                fontIcon='bi-file'
            />
        </SidebarMenuItemWithSub>
        
        
        { (hasRole(['Management'])) && 
        <>
        <SidebarMenuItem
            to='/company/prices/price-list'        
            title="Price List" 
            fontIcon='bi-archive'
            icon='/media/icons/duotune/finance/fin010.svg'
        />
        
        <SidebarMenuItemWithSub 
            to="/company/applicant-management/applicants" 
            title='Settings' 
            icon='/media/icons/duotune/general/gen062.svg'
        >
          <SidebarMenuItem
              to='/company/applicant-management/applicants'        
              title="Applicants" 
              icon='/media/icons/duotune/communication/com013.svg'
              fontIcon='bi-person'
          />
        </SidebarMenuItemWithSub>
        </>
        }    

        
        { (hasRole('Client Manager')) &&         
        <SidebarMenuItemWithSub 
            to="/company/client-manager/add-company" 
            title='Functions' 
            icon='/media/icons/duotune/general/gen003.svg'
        >
          <SidebarMenuItem
              to="/company/client-manager/add-company" 
              title="Add Company" 
              icon='/media/icons/duotune/general/gen069.svg'
              fontIcon='bi-person'
          />
        </SidebarMenuItemWithSub>
        }    

        


        </>
    )
}

export {ApplicantSidebarMenu};